import { useEffect, useRef } from "react";
import { selectMe, selectStatus } from "../ducks/auth/selectors";
import { useSelector } from "react-redux";
import { FirebaseMessaging } from "@capacitor-firebase/messaging";
import { isMobile } from "../helpers/mobile";
import useFeature from "../hooks/useFeature";
import { PluginListenerHandle } from "@capacitor/core";
import { useHandleRouteUpdatedNotification } from "./use-handle-route-updated-notification";
import { PushNotificationData } from "./types";
import { useAppDispatch } from "../redux-store";
import { useSendFirebaseToken } from "./useSendFirebaseToken";

const RegisterPushNotificationsListener = () => {
  const state = useSelector(selectStatus);
  const me = useSelector(selectMe);
  const mobilePushNotifications = useFeature("mobile-push-notifications");
  const dispatch = useAppDispatch();
  const notificationActionPerformedListener =
    useRef<PluginListenerHandle | null>(null);
  const firstTimeTokenSent = useRef(false);

  const handleRouteUpdatedNotification = useHandleRouteUpdatedNotification();
  const { sendToken: sendFirebaseToken } = useSendFirebaseToken();

  const ranAddListener = useRef(false);
  const ranRequestPermissions = useRef(false);

  useEffect(() => {
    if (isMobile && mobilePushNotifications) {
      if (!!me) {
        if (!ranAddListener.current) {
          FirebaseMessaging.addListener(
            "notificationActionPerformed",
            async (event) => {
              console.log(
                "### notificationActionPerformed: ",
                { event },
                { me }
              );
              const rawNotificationData = (event.notification as any).data.data;
              const notificationData = JSON.parse(
                rawNotificationData
              ) as PushNotificationData;
              switch (notificationData.type) {
                case "ROUTE_UPDATED":
                  await handleRouteUpdatedNotification(notificationData, me);
                  break;
                case "STOP_DOCUMENTS_ADDED":
                  await handleRouteUpdatedNotification(notificationData, me);
                  break;
                default:
                  console.warn("Unknown notification type", {
                    type: notificationData.type,
                    data: notificationData.data,
                  });
              }
            }
          ).then((listener) => {
            notificationActionPerformedListener.current = listener;
            ranAddListener.current = true;
          });
        }
      } else {
        if (notificationActionPerformedListener.current) {
          notificationActionPerformedListener.current.remove();
        }
      }
    }
  });

  useEffect(() => {
    // Save token when we are logged in
    if (
      isMobile &&
      !!me &&
      state === "AUTHENTICATED" &&
      mobilePushNotifications &&
      !ranRequestPermissions.current
    ) {
      ranRequestPermissions.current = true;
      FirebaseMessaging.requestPermissions().then((permissionResponse) => {
        console.log("permissionResponse: ", { permissionResponse });
        if (permissionResponse.receive === "denied") {
          console.warn("Permission for receiving notifications was denied");
          return;
        }

        if (!firstTimeTokenSent.current) {
          sendFirebaseToken().then((res) => {
            if (res) {
              firstTimeTokenSent.current = true;
            }
          });
        }
      });
    }
  }, [state, me, mobilePushNotifications, dispatch, sendFirebaseToken]);

  return null;
};

export default RegisterPushNotificationsListener;
